import React, { Component } from "react";

interface VolunteeringSegment {
  name: string;
  description: string;
  imageUrl: string;
}

interface Props {
  title: string;
  description: string;
  activities: VolunteeringSegment[];
}

export default class VolunteerAct extends Component<Props> {
  render() {
    return (
      <div className="bg-white">
        <div className="mx-auto py-12 px-4 sm:max-w-3xl lg:max-w-7xl sm:px-6 lg:px-8 lg:py-24">
          <div className="space-y-12">
            <div className="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
              <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl">
                {this.props.title}
              </h2>
              <p className="text-lg text-gray-700 font-body">
                {this.props.description}
              </p>
            </div>
            <ul className="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
              {this.props.activities.map((eachVolunteerAct) => (
                <li key={eachVolunteerAct.name}>
                  <div className="space-y-4">
                    <div className="aspect-w-3 aspect-h-2">
                      <img
                        className="object-cover"
                        src={eachVolunteerAct.imageUrl}
                        alt=""
                      />
                    </div>

                    <div className="space-y-2">
                      <div className="text-lg leading-6 font-medium space-y-1">
                        <h3 className="text-red-600">
                          {eachVolunteerAct.name}
                        </h3>
                        <p className="text-base text-gray-700 text-justify">
                          {eachVolunteerAct.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
